import SalesResultEdit from './SalesResultEdit';

export default SalesResultEdit;
